import {Middleware, PayloadAction} from '@reduxjs/toolkit';

import {useLoading} from '../zustand/useLoading';

export const loaderMiddleware: Middleware =
  () => next => (action: PayloadAction) => {
    const {skipLoading, startLoading, stopLoading} = useLoading.getState();

    if (skipLoading) return next(action);

    if (action.type.endsWith('/pending')) {
      startLoading();
    }

    if (
      action.type.endsWith('/fulfilled') ||
      action.type.endsWith('/rejected')
    ) {
      stopLoading();
    }

    return next(action);
  };
